module.exports = __webpack_public_path__ + "img/tpc-web-4.e674b802.webp";